'use client';

import type { Product } from '@eliadmin/core/src/api/slugs/types/slug-detail-types';
import {
  ProductCard,
  type ProductCardProps,
} from '@eliadmin/core/src/components/product/product-card';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { ProductListSchema } from '@eliadmin/core/src/components/seo/product-list-schema';
import { useGlobalStore } from '@eliadmin/core/src/stores/global-store';

export type ProductsGridProps = {
  products: Product[];
  emitSchema?: boolean;
  className?: {
    wrapper?: string;
    product?: ProductCardProps['className'];
  };
};
export function ProductsGrid(props: ProductsGridProps) {
  const currency = useGlobalStore(s => s.generalLayout?.currency);
  const schemaCurrency = useGlobalStore(s => s.generalLayout?.currency_code);

  return (
    <div
      className={cn(
        'grid grid-cols-1 gap-x-4 gap-y-6 sm:grid-cols-2 sm:gap-y-8 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3',
        'ea-product-list',
        props.className?.wrapper,
      )}
    >
      {props.emitSchema !== false && (
        <ProductListSchema products={props.products} currency={(schemaCurrency || currency)} />
      )}
      {props.products.map((product, index) => (
        <ProductCard
          key={product.id}
          product={product}
          imagePriority={index === 0}
          className={props.className?.product}
        />
      ))}
    </div>
  );
}
